import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7700feec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anmly-graph-header-box" }
const _hoisted_2 = {
  key: 0,
  class: "anmly-graph-header-title-box"
}
const _hoisted_3 = { class: "anmly-graph-header-word-space" }
const _hoisted_4 = { class: "anmly-graph-header-word-space" }
const _hoisted_5 = { class: "anmly-graph-header-info-tools-box" }
const _hoisted_6 = { class: "anmly-graph-header-anmly-count-box" }
const _hoisted_7 = { class: "anmly-graph-header-anmly-count-box" }
const _hoisted_8 = { class: "anmly-graph-header-anmly-count-box" }
const _hoisted_9 = { class: "anmly-graph-header-anmly-count-box" }

import { computed } from 'vue';
import GraphCardActionsV3 from '@/components/Common/GraphCardActionsV3.vue';
import {
  AnomalyDataObjectType,
  GraphDataNamesEnum,
} from '@/components/Common/graph.types';
import {
  severityKeyMapper,
  anomalyTypeColorMapper,
} from '@/components/charts/utils/utils.config';
import { useThemeToken } from '@/utils/theme/useThemeToken';
import { formatDate } from '@/utils/time/formatDate';

interface Props {
  selectedAnomalyInfo: AnomalyDataObjectType;
  anomaliesList: AnomalyDataObjectType[];
  handleZoomOut: () => void;
  handleZoomIn: () => void;
  handleReset: () => void;
  actionsIdPrefix: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnomalyGraphHeader',
  props: {
    selectedAnomalyInfo: {},
    anomaliesList: {},
    handleZoomOut: { type: Function },
    handleZoomIn: { type: Function },
    handleReset: { type: Function },
    actionsIdPrefix: {}
  },
  setup(__props: any) {

const props = __props;
const { token } = useThemeToken();

const getAnomalyCountInfo = computed(() => {
  let anomalyMapper = {
    [severityKeyMapper[1]]: 0,
    [severityKeyMapper[2]]: 0,
    [severityKeyMapper[3]]: 0,
  };

  props.anomaliesList.forEach((obj) => {
    anomalyMapper[severityKeyMapper[obj[GraphDataNamesEnum.SEVERITY]]]++;
  });
  anomalyMapper.total = props.anomaliesList.length;
  return anomalyMapper;
});

const getSelectedAnomalyFormattedData = computed(() => {
  const date =
    props.selectedAnomalyInfo.date &&
    formatDate(
      new Date(props.selectedAnomalyInfo.date).getTime(),
      0,
      'YYYY-MM-DD HH:mm A',
    );

  return {
    color: anomalyTypeColorMapper[props.selectedAnomalyInfo.sevKey || 4],
    label: props.selectedAnomalyInfo.type,
    date: date,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.selectedAnomalyInfo.sevKey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              style: _normalizeStyle({ backgroundColor: getSelectedAnomalyFormattedData.value.color }),
              class: "anmly-graph-header-sev-circle"
            }, null, 4),
            _createElementVNode("span", _hoisted_3, _toDisplayString(getSelectedAnomalyFormattedData.value.label), 1),
            _createElementVNode("span", _hoisted_4, " .  " + _toDisplayString(getSelectedAnomalyFormattedData.value.date) + "  . ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: "anmly-graph-header-anmly-count-value",
          style: _normalizeStyle({ color: _unref(token).colorPrimary })
        }, _toDisplayString(getAnomalyCountInfo.value.total), 5),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('anomalies')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", {
          class: "anmly-graph-header-anmly-count-value",
          style: _normalizeStyle({ color: _unref(token).colorPrimary })
        }, _toDisplayString(getAnomalyCountInfo.value[_unref(GraphDataNamesEnum).CRITICAL_BREACH]), 5),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('criticalAnomalies')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          class: "anmly-graph-header-anmly-count-value",
          style: _normalizeStyle({ color: _unref(token).colorPrimary })
        }, _toDisplayString(getAnomalyCountInfo.value[_unref(GraphDataNamesEnum).MAJOR_BREACH]), 5),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('majorAnomalies')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", {
          class: "anmly-graph-header-anmly-count-value",
          style: _normalizeStyle({ color: _unref(token).colorPrimary })
        }, _toDisplayString(getAnomalyCountInfo.value[_unref(GraphDataNamesEnum).MINOR_BREACH]), 5),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('minorAnomalies')), 1)
      ]),
      _createVNode(GraphCardActionsV3, {
        title: `modal-${_ctx.actionsIdPrefix}`,
        handleZoomOut: props.handleZoomOut,
        handleZoomIn: props.handleZoomIn,
        handleReset: props.handleReset,
        displayExpand: false
      }, null, 8, ["title", "handleZoomOut", "handleZoomIn", "handleReset"])
    ])
  ]))
}
}

})